import React from 'react';
import { LampDesk } from 'lucide-react';
import { useLocale } from '../../contexts/LocaleContext';

export function GoToMyDeskLabel(): React.ReactElement {
  const { t } = useLocale();

  return (
    <>
      <LampDesk className="h-4 w-4" aria-hidden="true" />
      {t('go_to_my_desk')}
    </>
  );
}
